export default __webpack_public_path__ + "static/media/alejandro-loguercio-holding-violin.cb8c6654.jpg";